import script from "./PlansPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansPage.vue?vue&type=script&setup=true&lang=js"

import "./PlansPage.vue?vue&type=style&index=0&id=77875611&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77875611"]])

export default __exports__